import { ISelectOption } from 'app/interfaces/ISelectOption';
import {
    DataFlowDataType, StringDataFlowType, IntegerDataFlowType,
    BooleanDataFlowType, DateDataFlowType, TimeStampDataFlowType,
    ShortDataFlowType, DoubleDataFlowType, FloatDataFlowType,
    LongDataFlowType, DecimalDataFlowType, BinaryDataFlowType,
    ByteDataFlowType, AnyDataFlowType
} from 'worker/app-workers/shared/models/dataflow-datatype';


export const dataFlowColumnTypeOptions: Array<ISelectOption<DataFlowDataType>> = [
    {
        label: stringResources.Variable_String,
        value: StringDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Integer,
        value: IntegerDataFlowType.TYPE
    },
    {
        label: stringResources.Variable_Boolean,
        value: BooleanDataFlowType.TYPE
    },
    {
        label: stringResources.Date,
        value: DateDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Timestamp,
        value: TimeStampDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Short,
        value: ShortDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Double,
        value: DoubleDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Float,
        value: FloatDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Long,
        value: LongDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Decimal,
        value: DecimalDataFlowType.TYPE
    },
    {
        label: stringResources.ModelName_BinaryDataset,
        value: BinaryDataFlowType.TYPE
    },
    {
        label: stringResources.DataFlowColumnType_Byte,
        value: ByteDataFlowType.TYPE
    },
    {
        label: stringResources.Any,
        value: AnyDataFlowType.TYPE
    }
];

export function getDataFlowColumnTypeIcon(typeName: string): string {
    switch ((typeName || '').toLowerCase()) {
        case 'bool':
        case 'boolean':
            return 'arg-type-icon svg-i-16x16-Bool';
        case 'date':
            return 'arg-type-icon svg-i-16x16-Date';
        case 'double':
            return 'arg-type-icon svg-i-16x16-Double';
        case 'float':
            return 'arg-type-icon svg-i-16x16-float';
        case 'int':
        case 'integer':
        case 'number':
            return 'arg-type-icon svg-i-16x16-Int';
        case 'long':
            return 'arg-type-icon svg-i-16x16-long';
        case 'short':
            return 'arg-type-icon svg-i-16x16-short';
        case 'decimal':
            return 'arg-type-icon svg-i-16x16-Decimal';
        case 'string':
            return 'arg-type-icon svg-i-16x16-String';
        case 'timestamp':
            return 'arg-type-icon svg-i-16x16-Timestamp';
        case 'array':
            return 'arg-type-icon svg-i-16x16-Array';
        case 'map':
            return 'arg-type-icon svg-i-16x16-map';
        case 'complex':
            return 'arg-type-icon svg-i-16x16-struct';
        case 'binary':
            return 'arg-type-icon svg-i-16x16-Binary';
        case 'byte':
            return 'arg-type-icon svg-i-16x16-Byte';
        case 'any':
        default:
            return handleAnyExtraTypesCase(typeName);
    }
}

export function getDataFlowExpressionBuilderTypeIcon(typeName: string): string {
    switch ((typeName || '').toLowerCase()) {
        case 'bool':
        case 'boolean':
            return 'arg-type-icon svg-i-16x16-Bool';
        case 'date':
        case 'datetime':
            return 'arg-type-icon svg-i-16x16-Date';
        case 'double':
        case 'float':
        case 'int':
        case 'integer':
        case 'long':
        case 'short':
        case 'decimal':
        case 'number':
            return 'arg-type-icon svg-i-16x16-Int';
        case 'string':
            return 'arg-type-icon svg-i-16x16-String';
        case 'timestamp':
            return 'arg-type-icon svg-i-16x16-Timestamp';
        case 'string[]':
        case 'short[]':
        case 'integer[]':
        case 'long[]':
        case 'float[]':
        case 'double[]':
        case 'boolean[]':
        case 'date[]':
        case 'timestamp[]':
        case 'array':
            return 'arg-type-icon svg-i-16x16-Array';
        case 'complex':
            return 'arg-type-icon svg-i-16x16-struct';
        case 'map':
            return 'arg-type-icon svg-i-16x16-map';
        case 'binary':
            return 'arg-type-icon svg-i-16x16-Binary';
        case 'byte':
            return 'arg-type-icon svg-i-16x16-Byte';
        case 'any':
        default:
            return handleAnyExtraTypesCase(typeName);
    }
}

function handleAnyExtraTypesCase(typeName: string): string {
    return typeName && typeName.startsWith('[') && typeName.endsWith(']') ? 'arg-type-icon svg-i-16x16-map' : 'arg-type-icon svg-i-16x16-Any';
}
